interface Props {
  propertyName: string
  address: string
  heroMessage: string | null
}

export function ConciergeHero({ propertyName, address, heroMessage }: Props) {
  return (
    <div className="gc-hero">
      <div className="gc-hero__topbar">
        <span className="gc-hero__brand">Stayframe</span>
      </div>

      <div className="gc-hero__circles" aria-hidden="true">
        <div className="gc-hero__circle gc-hero__circle--1" />
        <div className="gc-hero__circle gc-hero__circle--2" />
        <div className="gc-hero__circle gc-hero__circle--3" />
      </div>

      <div className="gc-hero__content">
        <div className="gc-hero__rule" />
        <h1 className="gc-hero__title">{propertyName}</h1>
        {address && <p className="gc-hero__address">{address}</p>}
        {heroMessage && (
          <p className="gc-hero__message">&ldquo;{heroMessage}&rdquo;</p>
        )}
        <div className="gc-hero__scroll">
          <div className="gc-hero__scroll-dot" />
          <span className="gc-hero__scroll-text">Scroll to explore</span>
        </div>
      </div>
    </div>
  )
}
